module.exports = __webpack_public_path__ + "img/login-bg-v4.1ec382ef.jpg";